/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  DeleteTeamsIdMutationResponse,
  DeleteTeamsIdPathParams,
  DeleteTeamsId400,
  DeleteTeamsId401,
  DeleteTeamsId403,
  DeleteTeamsId404,
  DeleteTeamsId500,
} from "../types/DeleteTeamsId.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteTeamsIdMutationKey = () => [{ url: "/teams/:id" }] as const;

export type DeleteTeamsIdMutationKey = ReturnType<
  typeof deleteTeamsIdMutationKey
>;

/**
 * @summary Расформирование команды (только капитан)
 * {@link /teams/:id}
 */
export async function deleteTeamsId(
  id: DeleteTeamsIdPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteTeamsIdMutationResponse,
    ResponseErrorConfig<
      | DeleteTeamsId400
      | DeleteTeamsId401
      | DeleteTeamsId403
      | DeleteTeamsId404
      | DeleteTeamsId500
    >,
    unknown
  >({ method: "DELETE", url: `/teams/${id}`, ...requestConfig });
  return res;
}

export function deleteTeamsIdMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const mutationKey = deleteTeamsIdMutationKey();
  return mutationOptions<
    ResponseConfig<DeleteTeamsIdMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsId400
      | DeleteTeamsId401
      | DeleteTeamsId403
      | DeleteTeamsId404
      | DeleteTeamsId500
    >,
    { id: DeleteTeamsIdPathParams["id"] },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ id }) => {
      return deleteTeamsId(id, config);
    },
  });
}

/**
 * @summary Расформирование команды (только капитан)
 * {@link /teams/:id}
 */
export function useDeleteTeamsId<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteTeamsIdMutationResponse>,
      ResponseErrorConfig<
        | DeleteTeamsId400
        | DeleteTeamsId401
        | DeleteTeamsId403
        | DeleteTeamsId404
        | DeleteTeamsId500
      >,
      { id: DeleteTeamsIdPathParams["id"] },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? deleteTeamsIdMutationKey();

  const baseOptions = deleteTeamsIdMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<DeleteTeamsIdMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsId400
      | DeleteTeamsId401
      | DeleteTeamsId403
      | DeleteTeamsId404
      | DeleteTeamsId500
    >,
    { id: DeleteTeamsIdPathParams["id"] },
    TContext
  >;

  return useMutation<
    ResponseConfig<DeleteTeamsIdMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsId400
      | DeleteTeamsId401
      | DeleteTeamsId403
      | DeleteTeamsId404
      | DeleteTeamsId500
    >,
    { id: DeleteTeamsIdPathParams["id"] },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<DeleteTeamsIdMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsId400
      | DeleteTeamsId401
      | DeleteTeamsId403
      | DeleteTeamsId404
      | DeleteTeamsId500
    >,
    { id: DeleteTeamsIdPathParams["id"] },
    TContext
  >;
}
